import apiConfig from '../../../../../../../config/api'
import {apiRequestorHelper} from '../../../../../../../helpers'

export const getPeopleMonitoredQuantityService = () => {
    return apiRequestorHelper({
        url: apiConfig.url + '/transaction/inside/getPeopleMonitoredQuantity',
        method: 'post',
        body: {}
    })
}